function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query getPbbRetryContext {\n    decagonPbbRetryContext {\n      status\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { useEffect, useRef } from 'react';
import { useLazyQuery } from '@apollo/client';
import window from 'global/window';
import gql from 'graphql-tag';
import _ from 'lodash';
import { formatName } from 'shared/helpers/users';
import generateDecagonUserAuth from 'shared/graphql/decagon/queries/generate-decagon-user-auth.gql';
import useStores from './use-stores';
import { hideZendeskWidget, showDecagonWidget, closeZendeskWidget } from '../helpers/tools';
var getPbbRetryContext = gql(_templateObject());
var PBB_RETRY_CONTEXT_TIMEOUT_MS = 2500;
var PBB_RETRY_CONTEXT_ERROR_SAMPLE_RATE = 0.01;
var logPbbRetryContextFailure = function() {
    if (Math.random() < PBB_RETRY_CONTEXT_ERROR_SAMPLE_RATE) {
        console.error('Failed to fetch Decagon PBB retry context');
    }
};
function fetchPbbRetryContextWithTimeout(fetchPbbRetryContext, abortController) {
    return _fetchPbbRetryContextWithTimeout.apply(this, arguments);
}
function _fetchPbbRetryContextWithTimeout() {
    _fetchPbbRetryContextWithTimeout = _async_to_generator(function(fetchPbbRetryContext, abortController) {
        var timeout, settleAbort, abortFallback, _result_errors, _result_data_decagonPbbRetryContext, _result_data, result, _error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    abortFallback = new Promise(function(resolve) {
                        settleAbort = function() {
                            return resolve(null);
                        };
                        abortController.signal.addEventListener('abort', settleAbort, {
                            once: true
                        });
                        timeout = setTimeout(function() {
                            return abortController.abort();
                        }, PBB_RETRY_CONTEXT_TIMEOUT_MS);
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.race([
                            fetchPbbRetryContext({
                                context: {
                                    fetchOptions: {
                                        signal: abortController.signal
                                    }
                                }
                            }),
                            abortFallback
                        ])
                    ];
                case 2:
                    result = _state.sent();
                    if ((result === null || result === void 0 ? void 0 : result.error) || (result === null || result === void 0 ? void 0 : (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.length)) {
                        logPbbRetryContextFailure();
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        (result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : (_result_data_decagonPbbRetryContext = _result_data.decagonPbbRetryContext) === null || _result_data_decagonPbbRetryContext === void 0 ? void 0 : _result_data_decagonPbbRetryContext.status) === 'active' ? {
                            status: 'active'
                        } : null
                    ];
                case 3:
                    _error = _state.sent();
                    if (!abortController.signal.aborted) {
                        logPbbRetryContextFailure();
                    }
                    return [
                        2,
                        null
                    ];
                case 4:
                    clearTimeout(timeout);
                    abortController.signal.removeEventListener('abort', settleAbort);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchPbbRetryContextWithTimeout.apply(this, arguments);
}
export default function useConsumerChatWidget() {
    var _useStores = useStores(), UI = _useStores.UI, User = _useStores.User, Cart = _useStores.Cart;
    var metadataSetRef = useRef(false);
    var _useLazyQuery = _sliced_to_array(useLazyQuery(generateDecagonUserAuth, {
        fetchPolicy: 'network-only'
    }), 1), fetchUserAuth = _useLazyQuery[0];
    var _useLazyQuery1 = _sliced_to_array(useLazyQuery(getPbbRetryContext, {
        fetchPolicy: 'network-only'
    }), 1), fetchPbbRetryContext = _useLazyQuery1[0];
    useEffect(function() {
        closeZendeskWidget();
        hideZendeskWidget();
        return initializeDecagon(UI);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function() {
        var retryContextAbortController = new AbortController();
        var mounted = true;
        var applyIdentity = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var auth, data, _data_generateDecagonUserAuth, error, metadata, retryContext;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!User.exists) return [
                                3,
                                6
                            ];
                            // Decagon establishes the conversation the moment setUserId fires, so the signed
                            // (signature, epoch) must be applied in the same turn — otherwise the conversation
                            // is tagged _decagon_has_valid_signature:false and never recovers. Lower envs
                            // without the HMAC secret return nulls and we fall through to unsigned.
                            auth = null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchUserAuth()
                            ];
                        case 2:
                            data = _state.sent().data;
                            auth = (_data_generateDecagonUserAuth = data === null || data === void 0 ? void 0 : data.generateDecagonUserAuth) !== null && _data_generateDecagonUserAuth !== void 0 ? _data_generateDecagonUserAuth : null;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error('Failed to fetch Decagon user auth signature', error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (!mounted || !window.duet) return [
                                2
                            ];
                            window.duet.setUserId(User.id);
                            if ((auth === null || auth === void 0 ? void 0 : auth.signature) && typeof auth.epoch === 'number') {
                                window.duet.setUserIdAuth(auth.signature, auth.epoch);
                            }
                            metadata = {
                                email: User.email,
                                name: User.fullName,
                                phone: User.phone,
                                userType: 'consumer'
                            };
                            return [
                                4,
                                fetchPbbRetryContextWithTimeout(fetchPbbRetryContext, retryContextAbortController)
                            ];
                        case 5:
                            retryContext = _state.sent();
                            if (retryContext) {
                                metadata.pbbRetryContext = retryContext;
                            }
                            if (mounted && window.duet) {
                                window.duet.setMetadata(metadata);
                            }
                            return [
                                3,
                                7
                            ];
                        case 6:
                            if (Cart.guestCustomer) {
                                window.duet.setMetadata({
                                    phone: Cart.guestCustomer.phone,
                                    name: formatName(Cart.guestCustomer),
                                    userType: 'consumer'
                                });
                            }
                            _state.label = 7;
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function applyIdentity() {
                return _ref.apply(this, arguments);
            };
        }();
        // Poll for window.duet to become available, then set metadata once
        var interval = setInterval(function() {
            if (window.duet && !metadataSetRef.current) {
                metadataSetRef.current = true;
                clearInterval(interval);
                applyIdentity().catch(function(err) {
                    return console.error('Failed to apply Decagon identity', err);
                });
            }
        }, 100);
        return function() {
            mounted = false;
            clearInterval(interval);
            retryContextAbortController.abort();
        };
    // Don't update mid-conversation or else Decagon clears the chat history and confuses the end user
    // Only set metadata once when window.duet becomes available
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchUserAuth,
        fetchPbbRetryContext
    ]);
}
function initializeDecagon(UI) {
    // Skip Decagon in E2E test environments - the widget's high z-index (99999999)
    // interferes with MUI modals during Playwright tests
    if (typeof window !== 'undefined' && window.__PLAYWRIGHT_TEST__) {
        return _.noop;
    }
    if (UI.isVariant("default") && !window.duet) {
        var decagonInitScript = document.createElement("script");
        decagonInitScript.id = "chat-loader";
        decagonInitScript.src = "https://decagon.ai/loaders/dutchie.js";
        decagonInitScript.async = true;
        document.body.appendChild(decagonInitScript);
    }
    // make sure it's not hidden from before
    showDecagonWidget();
    return function() {
        var _window_duet_hide, _window_duet;
        return (_window_duet = window.duet) === null || _window_duet === void 0 ? void 0 : (_window_duet_hide = _window_duet.hide) === null || _window_duet_hide === void 0 ? void 0 : _window_duet_hide.call(_window_duet);
    };
}
